import { inject, Injectable } from '@angular/core';
import { FormControl, TouchedChangeEvent } from '@angular/forms';

import { filter, Subscription } from 'rxjs';

import { FocusService } from '@ts/shared/util-focus';

@Injectable({
  providedIn: 'root',
})
export class FormFocusService {
  private focusService = inject(FocusService);

  private formControlSubscription?: Subscription;

  setAutofocus(element: HTMLElement, formControl: FormControl) {
    this.formControlSubscription?.unsubscribe();

    this.focusService.focus({ element });

    // We also want to focus every time the form is reset.
    // No need to unsubscribe manually, because the pipe will be closed when the form is destroyed.
    this.formControlSubscription = formControl.events
      .pipe(
        filter(
          (event) => event instanceof TouchedChangeEvent && !event.touched,
        ),
      )
      .subscribe(() => {
        this.focusService.focus({ element });
      });
  }
}
